import { render, staticRenderFns } from "./Responsibility.vue?vue&type=template&id=aa007bba"
import script from "./Responsibility.vue?vue&type=script&lang=js"
export * from "./Responsibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports